document.addEventListener("DOMContentLoaded", function () {
  const selector = document.querySelector(".swatch-selector[swatch-option='option3']");
  const dropdownList = document.querySelector(".swatch-drop-down-list");
  const listItems = dropdownList?.querySelectorAll("li");
  const hiddenInput = document.getElementById("hidden-ring-size");

  if (selector && dropdownList && hiddenInput) {
    selector.addEventListener("click", function (e) {
      e.stopPropagation();
      dropdownList.classList.toggle("swatch-hide");
      selector.setAttribute("aria-expanded", dropdownList.classList.contains("swatch-hide") ? "false" : "true");
    });

    listItems.forEach(function (item) {
      item.addEventListener("click", function () {
        const selectedText = item.textContent.trim();

        // Update selector display
        const spanInside = selector.querySelector("span[swatch-inside]");
        if (spanInside) {
          spanInside.textContent = selectedText;
        }

        // Update hidden input
        hiddenInput.value = selectedText;

        // Close dropdown and update classes
        dropdownList.classList.add("swatch-hide");
        selector.setAttribute("aria-expanded", "false");

        listItems.forEach(i => i.classList.remove("swatch-selected"));
        item.classList.add("swatch-selected");
      });
    });

    document.addEventListener("click", function (e) {
      if (!selector.contains(e.target) && !dropdownList.contains(e.target)) {
        dropdownList.classList.add("swatch-hide");
        selector.setAttribute("aria-expanded", "false");
      }
    });
  }

  const slider = document.querySelector('#custom-slider');
  const sliderInfo = document.querySelector('.custom-slider-info');
  const img = document.getElementById('background-image');

  // Carat range mapping
  const minCT = 0.25;
  const maxCT = 4.00;

  // Background-size mapping
  const minBgSize = 22;      // starting %
  const maxBgSize = 86.875;  // full zoom %

  function updateSlider() {
    const { value, max } = slider;

    // Carat calculation
    const carat = minCT + ((maxCT - minCT) * (value / max));
    sliderInfo.textContent = carat.toFixed(2);

    // Move label with thumb
    const sliderWidth = slider.offsetWidth;
    const thumbPos = (value / max) * sliderWidth;
    sliderInfo.style.left = `${thumbPos}px`;

    // Background-size calculation
    const bgSize = minBgSize + ((maxBgSize - minBgSize) * (value / max));
    img.style.backgroundSize = `${bgSize}%`;
  }

  // On load → set slider to max and update UI
  // window.addEventListener('load', () => {
    slider.value = slider.min;
    updateSlider();
  // });

  // Update when slider moves
  slider.addEventListener('input', updateSlider);


});


///////////////////////////////////////

document.addEventListener('DOMContentLoaded', function () {

  function faqAccordion() {
  const accoHeadings = document.querySelectorAll('.faq-accordian .acc-block-wrap .acco-head');

  accoHeadings.forEach(function (heading) {
    heading.addEventListener('click', function () {
      const selectedContent = heading.nextElementSibling;
      const isActive = heading.classList.contains('active');

      // Close all
      accoHeadings.forEach(function (otherHeading) {
        const otherContent = otherHeading.nextElementSibling;
        otherHeading.classList.remove('active');
        otherContent.classList.remove('active');
      });

      // If it wasn't active before, open it
      if (!isActive) {
        heading.classList.add('active');
        selectedContent.classList.add('active');
      }
    });
  });
}


  faqAccordion();
});


/////////////////////////////////////////////////////////

  document.addEventListener("DOMContentLoaded", function () {
  // Loop through each dropdown block
  document.querySelectorAll(".collections-list-dropdown-block .size").forEach(function (dropdown) {
    const sizesWrapper = dropdown.querySelector(".sizes-wrapper");
    const sizesList = dropdown.querySelector(".sizes");
    const selectedValue = dropdown.querySelector(".selected_value");

    if (!sizesWrapper || !sizesList || !selectedValue) return;

    // Toggle dropdown open/close
    sizesWrapper.addEventListener("click", function (e) {
      dropdown.classList.toggle("open");
    });

    // Handle selecting a collection
    sizesList.querySelectorAll(".size-label-add a").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        // Update selected value text
        selectedValue.textContent = this.textContent;

        // Close dropdown
        dropdown.classList.remove("open");

        // Redirect to the clicked collection
        window.location.href = this.getAttribute("href");
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove("open");
      }
    });
  });
});

//////////////////////////////////////////////////////////////////////